// extracted by mini-css-extract-plugin
module.exports = {"firstControlUnit":"_2OUDVv-nMN08yi43ko8xS_","flex":"_1qf000A9cQF4CR1EyUxT43","secondControlUnit":"BZ6fsMcQJnmm-ARYVWuna"};